import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tile-section',
  templateUrl: './tile-section.component.html',
  styleUrls: ['./tile-section.component.scss']
})
export class TileSectionComponent implements OnInit {
  @Input() elevated: boolean = true;
  @Input() headerKey: string | null = null;
  constructor() {}

  ngOnInit(): void {}
}
